import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from '@/lib/theme-context'
import { LanguageProvider } from '@/lib/language-context'
import { CartProvider } from '@/lib/cart-context'
import { AppRoutes } from '@/routes'
import { Toaster } from '@/components/ui/sonner'
import ScrollToTop from '@/components/scroll-to-top'

export default function App() {
    return (
        <BrowserRouter>
            <ThemeProvider defaultTheme="light">
                <LanguageProvider>
                    <ScrollToTop />
                    <CartProvider>
                        <AppRoutes />
                        <Toaster />
                    </CartProvider>
                </LanguageProvider>
            </ThemeProvider>
        </BrowserRouter>
    )
}
